import { AppTheme, AppThemeManager } from "owa-acui";

let currentAppTheme: AppTheme;

/** Verifies that the correct `AppTheme` mode is in use, and (if not) loads that theme. */
export const updateAppThemeMode = (isDarkTheme: boolean): void => {
    const appThemeManager = AppThemeManager.getInstance();
    const targetAppTheme: AppTheme = isDarkTheme ? AppTheme.Dark : AppTheme.Light;
    
    if (currentAppTheme !== targetAppTheme) {
        appThemeManager.loadTheme(targetAppTheme);
        currentAppTheme = targetAppTheme;
    }
};
